// Inline widgets for product listing (grid + list + detail views)

function webshop_uom_selector_html(item_code, sellable_uoms, sales_uom, route) {
	if (!sellable_uoms || sellable_uoms.length <= 1) {
		return '';
	}
	let options = sellable_uoms.map(uom =>
		`<option value="${uom}" ${uom === sales_uom ? 'selected' : ''}>${uom}</option>`
	).join('');
	return `
		<div class="uom-selector-container mb-1" style="width:100%;">
			<select class="form-control form-control-sm uom-select"
				data-item-code="${item_code}"
				data-route="${route || ''}"
				data-current-uom="${sales_uom || ''}"
				style="max-width:200px;">
				${options}
			</select>
		</div>
	`;
}

function webshop_action_html(item_code, item_or_info, view, settings) {
	const info = item_or_info || {};
	const in_cart = info.in_cart;
	const cart_qty = info.cart_qty || 0;
	const uom = info.sales_uom || info.uom || '';

	if (settings && settings.enabled) {
		if (in_cart && cart_qty > 0) {
			return webshop_qty_selector_html(item_code, cart_qty, view, uom);
		} else {
			return webshop_add_to_cart_html(
				item_code,
				view,
				uom,
				settings.enable_checkout ? __("Add to Cart") : __("Add to Quote")
			);
		}
	}
	return '';
}

function webshop_qty_selector_html(item_code, qty, view, uom) {
    let wrapper_cls = 'list-qty-selector';
    let input_group_style = 'width:100%;';
    let input_style = 'min-width:32px;height:28px;font-size:13px;border:none;background:var(--gray-100);text-align:center;width:100%;';
    if (view === 'grid') {
        wrapper_cls = 'grid-qty-selector mt-2';
    } else if (view === 'detail') {
        wrapper_cls = 'detail-qty-selector d-flex align-items-center mt-3';
        input_group_style = 'display:flex;flex-wrap:nowrap;align-items:stretch;width:auto;';
        input_style = 'min-width:48px;height:38px;font-size:14px;border:1px solid var(--gray-300);background:#fff;text-align:center;width:70px;';
    }

    return `
        <div class="${wrapper_cls}" data-item-code="${item_code}" data-uom="${uom || ''}">
            <div class="input-group number-spinner" style="${input_group_style}">
                <span class="input-group-prepend d-sm-inline-block">
                    <button class="btn cart-btn qs-btn" data-item-code="${item_code}" data-uom="${uom || ''}" data-action="decrease">−</button>
                </span>
                <input type="number" class="qs-qty cart-qty text-center" data-item-code="${item_code}" data-uom="${uom || ''}"
                    value="${qty}" min="0"
                    style="${input_style}">
                <span class="input-group-append d-sm-inline-block">
                    <button class="btn cart-btn qs-btn" data-item-code="${item_code}" data-uom="${uom || ''}" data-action="increase">+</button>
                </span>
            </div>
            <div class="remove-cart-item d-flex ml-2" data-item-code="${item_code}" data-uom="${uom || ''}" style="cursor:pointer;">
                <span>
                    <svg class="icon sm remove-cart-item-logo" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.146 11.217a.5.5 0 1 0 .708.708l3.182-3.182 3.181 3.182a.5.5 0 1 0 .708-.708l-3.182-3.18 3.182-3.182a.5.5 0 1 0-.708-.708l-3.18 3.181-3.183-3.182a.5.5 0 0 0-.708.708l3.182 3.182-3.182 3.181z" stroke-width="0"></path>
                    </svg>
                </span>
            </div>
        </div>
    `;
}

function webshop_update_bubble(item_code, qty, uom) {
    let selector = `.cart-indicator[data-item-code="${item_code}"], .list-cart-indicator[data-item-code="${item_code}"]`;
    if (uom) {
        selector = `.cart-indicator[data-item-code="${item_code}"][data-uom="${uom}"], .list-cart-indicator[data-item-code="${item_code}"][data-uom="${uom}"]`;
    }
    $(selector).each(function() {
        if (qty > 0) {
            $(this).text(qty).removeClass('hidden');
        } else {
            $(this).addClass('hidden');
        }
    });
}

function webshop_price_html(info) {
    if (!info || !info.price) return '';
    const price = info.price;
    let html = price.formatted_price_sales_uom || price.formatted_price || '';
    if (price.formatted_mrp) {
        html += ` <small class="striked-price"><s>${price.formatted_mrp}</s></small>`;
        const discount = price.formatted_discount_percent || price.formatted_discount_rate;
        if (discount) {
            html += ` <small class="ml-1 product-info-green">-${discount}</small>`;
        }
    }
    return html;
}

function webshop_add_to_cart_html(item_code, view, uom, btn_text) {
    const text = btn_text || (view === 'detail' ? __("Add to Cart") : __("Add to Cart"));
    if (view === 'grid') {
        return `
            <div class="btn btn-sm btn-primary btn-add-to-cart-list w-100 mt-2"
                data-item-code="${item_code}" data-uom="${uom || ''}">
                <svg class="icon icon-sm" style="stroke:white;fill:none;flex-shrink:0;">
                    <use href="#icon-assets"></use>
                </svg>
                ${text}
            </div>
        `;
    } else if (view === 'detail') {
        return `
            <button class="btn btn-primary btn-add-to-cart-list"
                data-item-code="${item_code}" data-uom="${uom || ''}"
                style="min-width:140px;">
                <svg class="icon icon-sm mr-1" style="stroke:white;fill:none;vertical-align:middle;">
                    <use href="#icon-assets"></use>
                </svg>
                ${text}
            </button>
        `;
    } else {
        return `
            <div class="btn btn-sm btn-primary btn-add-to-cart-list mb-0"
                data-item-code="${item_code}" data-uom="${uom || ''}">
                <svg class="icon icon-sm" style="stroke:white;fill:none;flex-shrink:0;margin-right:4px;">
                    <use href="#icon-assets"></use>
                </svg>
                <span class="cart-btn-text">${text}</span>
            </div>
        `;
    }
}

function webshop_swap_to_add_to_cart(item_code, uom) {
    $('.grid-qty-selector[data-item-code="' + item_code + '"]').replaceWith(webshop_add_to_cart_html(item_code, 'grid', uom));
    $('.list-qty-selector[data-item-code="' + item_code + '"]').replaceWith(webshop_add_to_cart_html(item_code, 'list', uom));
    $('.detail-qty-selector[data-item-code="' + item_code + '"]').replaceWith(webshop_add_to_cart_html(item_code, 'detail', uom));
    webshop_update_bubble(item_code, 0, uom);
}

function webshop_swap_to_qty_selector(item_code, uom, qty) {
    qty = qty || 1;
    $('.grid-qty-selector[data-item-code="' + item_code + '"]').each(function() {
        $(this).replaceWith(webshop_qty_selector_html(item_code, qty, 'grid', uom));
    });
    $('.list-qty-selector[data-item-code="' + item_code + '"]').each(function() {
        $(this).replaceWith(webshop_qty_selector_html(item_code, qty, 'list', uom));
    });
    $('.detail-qty-selector[data-item-code="' + item_code + '"]').each(function() {
        $(this).replaceWith(webshop_qty_selector_html(item_code, qty, 'detail', uom));
    });
    webshop_update_bubble(item_code, qty, uom);
}

function sync_qty_across_views(item_code, new_qty, uom) {
    let uom_selector = uom ? `[data-uom="${uom}"]` : '';
    $(`.grid-qty-selector[data-item-code="${item_code}"]${uom_selector} .qs-qty, .list-qty-selector[data-item-code="${item_code}"]${uom_selector} .qs-qty`).val(new_qty);
    if (uom) {
        $(".cart-indicator[data-item-code='" + item_code + "'][data-uom='" + uom + "']").text(new_qty).toggleClass("hidden", new_qty <= 0);
    }
}

// Ensure Add-to-Cart / Qty selector widgets match the actual cart state.
// This is needed after browser back/forward navigation (bfcache) where the
// server-rendered DOM may reflect an older cart.
function webshop_sync_button_states() {
    if (!window._cart_items) return;

    // Promote Add-to-Cart buttons to qty selectors for items that are in the cart
    $('.btn-add-to-cart-list[data-item-code]').each(function() {
        const $btn = $(this);
        const item_code = $btn.data('item-code');
        const uom = $btn.data('uom') || '';
        const qty = (window._cart_items[item_code] || {})[uom] || 0;
        if (qty > 0) {
            let view = 'list';
            if ($btn.closest('.item-card').length > 0) view = 'grid';
            else if ($btn.closest('.item-cart').length > 0) view = 'detail';
            $btn.replaceWith(webshop_qty_selector_html(item_code, qty, view, uom));
        }
    });

    // Convert qty selectors back to Add-to-Cart buttons for items no longer in the cart
    $('.grid-qty-selector[data-item-code], .list-qty-selector[data-item-code], .detail-qty-selector[data-item-code]').each(function() {
        const $qs = $(this);
        const item_code = $qs.data('item-code');
        const uom = $qs.data('uom') || '';
        const qty = (window._cart_items[item_code] || {})[uom] || 0;
        if (!qty) {
            let view = 'list';
            if ($qs.hasClass('grid-qty-selector')) view = 'grid';
            else if ($qs.hasClass('detail-qty-selector')) view = 'detail';
            $qs.replaceWith(webshop_add_to_cart_html(item_code, view, uom));
        }
    });
}

$(document).ready(function() {

    // Qty +/- buttons
    $(document).on('click', '.qs-btn', function(e) {
        e.stopPropagation();
        var $btn = $(this);
        if ($btn.prop('disabled')) return;
        $btn.prop('disabled', true);
        var item_code = $btn.data('item-code');
        var action = $btn.data('action');
        var $qs = $btn.closest('.grid-qty-selector, .list-qty-selector, .detail-qty-selector');
        var $display = $qs.find('.qs-qty[data-item-code="' + item_code + '"]');
        var current = parseInt($display.val()) || 0;
        var new_qty = action === 'increase' ? current + 1 : Math.max(0, current - 1);

        var uom = $btn.data('uom') || $qs.data('uom') || null;
        webshop.webshop.shopping_cart.update_cart({
            item_code: item_code,
            qty: new_qty,
            uom: uom,
            callback: function(r) {
                $btn.prop('disabled', false);
                if (new_qty <= 0) {
                    webshop_swap_to_add_to_cart(item_code, uom);
                    sync_qty_across_views(item_code, 0, uom);
                } else {
                    $display.val(new_qty);
                    webshop_update_bubble(item_code, new_qty, uom);
                    sync_qty_across_views(item_code, new_qty, uom);
                }
            }
        });
    });

    // Remove button (X)
    $(document).on('click', '.grid-qty-selector .remove-cart-item, .grid-qty-selector .remove-cart-item *, .list-qty-selector .remove-cart-item, .list-qty-selector .remove-cart-item *, .detail-qty-selector .remove-cart-item, .detail-qty-selector .remove-cart-item *', function(e) {
        e.stopPropagation();
        var $qs = $(this).closest('.grid-qty-selector, .list-qty-selector, .detail-qty-selector');
        if (!$qs.length) return;
        var item_code = $qs.data('item-code');
        var uom = $qs.data('uom') || null;

        webshop.webshop.shopping_cart.update_cart({
            item_code: item_code,
            qty: 0,
            uom: uom,
            callback: function(r) {
                webshop_swap_to_add_to_cart(item_code, uom);
                sync_qty_across_views(item_code, 0, uom);
            }
        });
    });

    // Direct input change with debounce
    var input_timer = null;
    $(document).on('change', '.grid-qty-selector .qs-qty, .list-qty-selector .qs-qty, .detail-qty-selector .qs-qty', function(e) {
        clearTimeout(input_timer);
        var $input = $(this);
        var item_code = $input.data('item-code');
        var $qs = $input.closest('.grid-qty-selector, .list-qty-selector, .detail-qty-selector');
        var new_qty = parseInt($input.val()) || 0;
        if (new_qty < 0) new_qty = 0;

        input_timer = setTimeout(function() {
            var uom = $input.data('uom') || $qs.data('uom') || null;
            webshop.webshop.shopping_cart.update_cart({
                item_code: item_code,
                qty: new_qty,
                uom: uom,
                callback: function(r) {
                    if (new_qty <= 0) {
                        webshop_swap_to_add_to_cart(item_code, uom);
                        sync_qty_across_views(item_code, 0, uom);
                    } else {
                        $input.val(new_qty);
                        webshop_update_bubble(item_code, new_qty, uom);
                        sync_qty_across_views(item_code, new_qty, uom);
                    }
                }
            });
        }, 500);
    });

    // Initialize qty selectors from existing cart on page load (per UOM)
    function init_qty_selectors() {
        frappe.call({
            method: "webshop.webshop.shopping_cart.cart.get_cart_quotation",
            callback: function(r) {
                if (!r.message || !r.message.doc) return;
                var items = r.message.doc.items || [];
                window._cart_items = {};
                items.forEach(function(item) {
                    var item_code = item.item_code;
                    var uom = item.uom;
                    var qty = item.qty || 0;
                    window._cart_items[item_code] = window._cart_items[item_code] || {};
                    window._cart_items[item_code][uom] = qty;
                    webshop_update_bubble(item_code, qty, uom);
                    // Grid / list selectors are keyed by item + UOM
                    $('.qs-qty[data-item-code="' + item_code + '"][data-uom="' + uom + '"]').val(qty);
                    // Detail page has one selector visible at a time; only update if its UOM matches
                    $('.detail-qty-selector[data-item-code="' + item_code + '"]').each(function() {
                        var $detail = $(this);
                        if (($detail.data('uom') || '') === uom) {
                            $detail.find('.qs-qty').val(qty);
                        }
                    });
                });

                // After restoring bubble/input values, make sure the button/qty-selector
                // widgets themselves match the cart state (important when the page was
                // restored from the browser back-forward cache with stale DOM).
                webshop_sync_button_states();
            }
        });
    }

    if (frappe.session && frappe.session.user && frappe.session.user !== "Guest") {
        setTimeout(init_qty_selectors, 800);
        $(window).on('pageshow', function() {
            setTimeout(init_qty_selectors, 500);
        });
    }
});

// Expose helpers on window so inline templates and other bundles can reach them.
// Keeping the local declarations lets the same file work both bundled and standalone.
window.webshop_uom_selector_html = webshop_uom_selector_html;
window.webshop_action_html = webshop_action_html;
window.webshop_qty_selector_html = webshop_qty_selector_html;
window.webshop_update_bubble = webshop_update_bubble;
window.webshop_add_to_cart_html = webshop_add_to_cart_html;
window.webshop_swap_to_add_to_cart = webshop_swap_to_add_to_cart;
window.webshop_swap_to_qty_selector = webshop_swap_to_qty_selector;
window.sync_qty_across_views = sync_qty_across_views;
window.webshop_price_html = webshop_price_html;
window.webshop_sync_button_states = webshop_sync_button_states;